import React from 'react';
import classNames from "classnames";
import styles from "../../styles/standings-widget.module.scss";
import {StandingsWidgetPointsDeductionsCompetitor} from "./standings-widget.points-deductions.competitor";

export const StandingsWidgetPointsDeductionsRow = ({point}) => {
  const {deductionText} = point;

  return <div className={classNames(styles.points_deductions_row)}>
    <StandingsWidgetPointsDeductionsCompetitor point={point}/>
    {deductionText}
  </div>
};